import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import { AppState } from 'src/store';

export const userIsAuthenticated = connectedRouterRedirect({
  redirectPath: '/login',
  authenticatedSelector: ({ authState }: AppState) => {
    return (authState.status === 'loggedIn' ? !!authState.userInfo : false);
  },
  authenticatingSelector: (state: AppState) => state.authState.status === 'loading',
  wrapperDisplayName: 'UserIsAuthenticated'
});



// WEBPACK FOOTER //
// ./src/authWrapper.ts